import ImageItem from "./ImageItem";

interface ImageType {
    id: string;
    url: string;
    name: string;
}

interface ImageGridProps {
    images: ImageType[];
    selectedIds: string[];
    setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
    onDelete: (id: string) => void;
}

export default function ImageGrid({
    images,
    selectedIds,
    setSelectedIds,
    onDelete,
}: ImageGridProps) {
    const toggleSelect = (id: string) => {
        setSelectedIds((prev) => {
            if (prev.includes(id)) {
                return prev.filter((i) => i !== id);
            }
            return [...prev, id];
        });
    };

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {images.map((img) => {
                const index = selectedIds.indexOf(img.id);
                const selected = index !== -1;

                return (
                    <ImageItem
                        key={img.id} // 🔥 bắt buộc unique
                        image={img}
                        selected={selected}
                        index={index}
                        onSelect={toggleSelect}
                        onDelete={onDelete}
                    />
                );
            })}
        </div>
    );
}